import SEOHead from '../components/base/SEOHead';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <SEOHead
        title="Page Not Found – KaliKare Homecare"
        description="The page you are looking for could not be found."
        canonical="/404"
        noindex={true}
      />
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-4">Page Not Found</h2>
        <p className="text-gray-600 mb-8">The page you are looking for could not be found.</p>
        <Link
          to="/"
          className="inline-block bg-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors whitespace-nowrap"
        >
          Return Home
        </Link>
      </div>
    </div>
  );
}